import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ConfigService } from '@services/config.service';
import { WindowReferenceService } from '@services/window-reference.service';

@Component({
    selector: 'app-portal',
    templateUrl: './portal.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class PortalComponent implements OnInit {

  constructor(
    private readonly configService: ConfigService,
    private readonly windowRef: WindowReferenceService,
  ) {}

  ngOnInit(): void {
    const url = this.configService.getConfig().URL_LOGIN_UNIFICADO;
    this.windowRef.navigateTo(url);
  }
}
